// 便利関数

/**
 * URLパラメータを取得する
 * 引数のパラメータを取得する
 * 
 * @param {string} key パラメータ
 * @return {string} パラメータ値
 */
export const getUrlParam = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    const keyword = urlParams.get(key); // keyのパラメータがない場合はnull
    return keyword;
}

/**
* HTMLタグを文字列から除去する
* 第二引数にHTMLタグを指定した場合、指定されたHTMLタグは除去されずに残る
* 
* @param      {string}       str            処理対象の文字列
* @param      {string|Array} arrowTag       許容するHTMLタグ名。配列形式で複数指定可能。
* @return     {string}       タグが除去された文字列
*/
export const removeTag = (str, arrowTag) => {
   // 配列形式の場合は'|'で結合
   if ((Array.isArray ?
       Array.isArray(arrowTag)
       : Object.prototype.toString.call(arrowTag) === '[object Array]')
   ) {
       arrowTag = arrowTag.join('|');
   }

   // arrowTag が空の場合は全てのHTMLタグを除去する
   arrowTag = arrowTag ? arrowTag : '';

   // パターンを動的に生成
   var pattern = new RegExp('(?!<\\/?(' + arrowTag + ')(>|\\s[^>]*>))<("[^"]*"|\\\'[^\\\']*\\\'|[^\\\'">])*>', 'gim');

   return str.replace(pattern, '');
}

/**
 * HTMLアンエスケープ
 * DB上で「&lt;」などとなっている箇所が画面上でHTMLの開始タグでなく「&lt;」という文字で認識されてしまっていたので、置換
 * @param {String} str 変換したい文字列
 */
 export const unEscapeHTML = function (str) {
    if(!str) {
        return "";
    }
    return str
            .replace(/(&lt;)/g, '<')
            .replace(/(&gt;)/g, '>')
            .replace(/(&quot;)/g, '"')
            .replace(/(&#39;)/g, "'")
            .replace(/(&amp;)/g, '&');
};